module.exports = __webpack_public_path__ + "static/media/IconUserPolisi.05e35ecc.svg";